(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-app.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-app.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  BankidFooter
} = svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.components;
const BankidApp = _ref => {
  let {
    onCancel,
    isDeposit = false
  } = _ref;
  const handleCancel = () => {
    onCancel();
  };
  return React.createElement("div", {
    className: "margin-top-2 align-center"
  }, React.createElement("div", null, "Starta din BankID-app"), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    onClick: handleCancel,
    transparent: true
  }, "Avbryt"), React.createElement(BankidFooter, {
    isDeposit: isDeposit
  }));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.BankidApp = BankidApp;

 })(window);